import React from 'react'
import {  Row, Spin } from "antd";
import { LoadingOutlined } from '@ant-design/icons';
export const Loading = () => {
    return (
        <Row
            style={{
                height: "100dvh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Spin indicator={<LoadingOutlined style={{ fontSize: 70, color: "rgb(174,32,114)" }} spin />} spinning={true}></Spin>
            </div>
        </Row>
    )
}
